import { render, staticRenderFns } from "./LimbSetupModule.vue?vue&type=template&id=413737db&"
import script from "./LimbSetupModule.vue?vue&type=script&lang=js&"
export * from "./LimbSetupModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports